import * as React from 'react';
import * as courseTopics from '../styles/courseTopics.module.scss';

export const CourseTopics = () => {
  return (
    <section className={courseTopics.courseTopics}>
      <div className={'container'}>
        <div className={`row ${courseTopics.courseTopics__wrapper}`}>
          <div className={`col-12 col-lg-4 ${courseTopics.courseTopics__info}`}>
            <img
              src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/frame-250.png'}
              alt={'Frame'}
            />
          </div>
          <div className={`col-12 col-lg-8 ${courseTopics.courseTopics__topicCards}`}>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/01-house.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/02-school.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/03-character.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/04-appearance.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/05-pets.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/06-profession.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/07-weather.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/08-food.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/09-clothes.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/10-shop.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/11-city.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/12-travel.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/13-health.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/14-sport.png'}
                alt={'Тема'}
              />
            </div>
            <div className={courseTopics.courseTopics__topicCard}>
              <img
                className={courseTopics.courseTopics__topicCardImg}
                src={'https://fs.advance.ru/landing-pages/course/angliyskaya-leksika-dlya-detey/15-hobby.png'}
                alt={'Тема'}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
